var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlignRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 4h14v1H6zm0 6h14v1H6zm0 6h14v1H6zm-6-3h20v1H0zm0-6h20v1H0z"
})));
export { SvgAlignRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgNGgxNHYxSDZ6bTAgNmgxNHYxSDZ6bTAgNmgxNHYxSDZ6bS02LTNoMjB2MUgwem0wLTZoMjB2MUgweiIvPjwvc3ZnPgo=";